
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m28.5 25.1l6.2 35.4c.7 3.9 25-.3 24.3-4.3l-1.3-7.2c2.5-1.9 4-5.2 4.2-8 .2-2.9-.4-8.5-1.4-11.3-.8-2.2-3.9-1.9-6.5-1.3l-1.3-7.4-24.2 4.1m28.6 20.1l-2.4-13.6c1.5-.3 3-.3 3.4.8.8 2.5.9 6.4.8 9-.2 1.4-.8 2.7-1.8 3.8m-26.5-18.2l20.9-3.7 5.4 30.4c.6 3.2-20.3 6.9-20.9 3.7l-5.4-30.4", fill: "#a1b8c7", opacity: ".8" }),
	React.createElement("path", { d: "m52.2 34.1l-18.7 3.3 3.3 18.9c.5 2.9 19.2-.4 18.7-3.3l-3.3-18.9", fill: "#fdb73e" }),
	React.createElement("path", { d: "m26.6 26.5c-.3-4.2 5-7.2 8.9-5.5 1.3-3.6 5.9-3.6 7.9-1.8 1.6-.9 5.2-1.5 7.1.5 3.9-1.6 7.2 4.6 1 5.3-9-1.5-19.1 16.5-19.1 16.5-1.7.3-4-.5-3.5-3.2-1 .1-2.6-1.6-2.2-3.2-4.1-1.1-3.8-7.5-.1-8.6", fill: "#d8d2b8" }),
	React.createElement("path", { d: "m27.4 26.9c-.3-4.7 5.9-6.4 8.7-5.3 1-2.7 5-3.9 7.3-1.7 1.2-.8 5-1.6 6.8.3 4.2-1.7 6.2 5 .4 4.9l1.6 9-13.6 2.4c-.1 1-1.5 2-3.2 1.7.3 1.7-1.4 3.2-3 3.4-1.9.2-3.4-1.6-2.6-3.7-1.8 0-2.6-1.6-2.2-3-3.9-1-3.9-7.2-.2-8", fill: "#fff" }),
	React.createElement(
		"g",
		{ fill: "#fee0af" },
		React.createElement("path", { d: "m46.6 37c2.1-.4 4.2 1 4.5 3 .4 2.1-1.1 4-3.2 4.4-2.1.4-4.2-1-4.5-3-.4-2 1.1-4 3.2-4.4" }),
		React.createElement("ellipse", { cx: "42.7", cy: "47.9", rx: "3", ry: "2.8", transform: "matrix(.9848-.1736.1736.9848-7.6637 8.1429)" }),
		React.createElement("ellipse", { cx: "48.9", cy: "49.4", rx: "2", ry: "1.9", transform: "matrix(.9848-.1735.1735.9848-7.8355 9.2385)" }),
		React.createElement("path", { d: "m45.1 52.8c.8-.1 1.5.3 1.6 1.1.1.7-.4 1.4-1.1 1.5-.8.1-1.5-.3-1.6-1.1-.2-.6.3-1.3 1.1-1.5" })
	),
	React.createElement("path", { d: "m12.2 11.1l-1.4 8.2c-2.9-.7-6.3-.9-7.1 1.5-1.2 3.1-1.9 9.3-1.7 12.4.2 3.2 1.9 6.7 4.7 8.8l-1.4 8c-.8 4.3 25.9 9 26.7 4.7l6.9-38.9-26.7-4.7m-6.7 22.8c-.2-2.9-.1-7.2.9-9.9.4-1.2 2-1.3 3.7-.9l-2.7 14.9c-1.1-1.2-1.8-2.7-1.9-4.1m25.2 17.5c-.6 3.5-23.6-.5-22.9-4l5.9-33.5 23 4-6 33.5", fill: "#a1b8c7", opacity: ".8" }),
	React.createElement("path", { d: "m12.8 25.7l20.5 3.6-3.6 20.8c-.6 3.1-21.1-.5-20.5-3.6l3.6-20.8", fill: "#fdb73e" }),
	React.createElement("path", { d: "m41 17.4c.3-4.7-5.5-7.9-9.8-6.1-1.4-3.9-6.5-4-8.7-1.9-1.8-1-5.8-1.7-7.8.6-4.3-1.8-7.9 5.1-1.1 5.8 10-1.7 21 18.2 21 18.2 1.9.3 4.4-.6 3.8-3.6 1.1.2 2.8-1.8 2.5-3.5 4.4-1.2 4.1-8.3.1-9.5", fill: "#d8d2b8" }),
	React.createElement("path", { d: "m40 17.9c.3-5.2-6.5-7.1-9.5-5.8-1.1-2.9-5.5-4.3-8.1-1.9-1.3-.9-5.4-1.8-7.4.3-4.6-1.8-6.9 5.5-.5 5.4l-1.7 9.9 15 2.6c.1 1.1 1.7 2.2 3.5 1.9-.4 1.9 1.5 3.6 3.3 3.8 2 .2 3.8-1.8 2.8-4 2 0 2.8-1.8 2.4-3.3 4.3-1.3 4.3-8.1.2-8.9", fill: "#fff" }),
	React.createElement(
		"g",
		{ fill: "#d8d2b8" },
		React.createElement("path", { d: "m32.7 14.9c.2-1.8-1.2-4-4.5-3.3-.4-.8-1.3-1.2-2.7-.4 1.6 0 2.1.5 2.4 1.3 3.3 0 3.6 3 3.6 3s1.4.1 1.8 1.9c.6-.8.5-2-.6-2.5" }),
		React.createElement("path", { d: "m34.5 22.3c-2.4-2.3-4.8-1.3-5.6.3-1.2-.2-1.9.7-2 1.6 1.4-1.3 2.6-.6 2.6-.6s1.9-2.3 4.7-.5c.7-.6 1.4-.6 2.7.2-.7-1.3-1.6-1.4-2.4-1" })
	),
	React.createElement(
		"g",
		{ fill: "#fee0af" },
		React.createElement("path", { d: "m18.9 28.9c-2.4-.4-4.6 1.1-5 3.3-.4 2.3 1.2 4.4 3.6 4.9 2.4.4 4.6-1.1 5-3.3.4-2.3-1.2-4.4-3.6-4.9" }),
		React.createElement("ellipse", { cx: "23.2", cy: "40.9", rx: "3.1", ry: "3.3", transform: "matrix(.1733-.9849.9849.1733-21.1092 56.6803)" }),
		React.createElement("path", { d: "m16.7 40.6c-1.2-.2-2.3.5-2.5 1.7-.2 1.1.6 2.2 1.8 2.4 1.2.2 2.3-.5 2.5-1.7.2-1.1-.6-2.2-1.8-2.4" }),
		React.createElement("path", { d: "m20.6 46.4c-.8-.1-1.6.4-1.8 1.2-.1.8.4 1.5 1.2 1.7.8.1 1.6-.4 1.8-1.2.2-.8-.3-1.6-1.2-1.7" })
	),
	React.createElement(
		"g",
		{ fill: "#42ade2" },
		React.createElement("path", { d: "m44.5 14.8l9.6-8.3-4.6-3.3z" }),
		React.createElement("path", { d: "m48.9 16.5l9.1 2v-4.8z" }),
		React.createElement("path", { d: "m41.3 11.7l2.3-9.7h-4.9z" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/beers.js
// module id = 682
// module chunks = 0